import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy styled-components (baseline)
import styled from 'styled-components/macro';

const StyledScrollBar = styled.div`
    ${({ style }) => style}

    border-radius: inherit;

    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;

    transition: background-color 0.1s linear;

    &:hover {
        background-color: #989898;
    }
`;

const renderThumb = ({ style, ...props }) => {
    // eslint-disable-next-line tpe/no-props-spread, tpe/no-inline-style -- TODO: legacy props spread (baseline); TODO: legacy inline style (baseline)
    return <StyledScrollBar style={{ ...style }} {...props} />;
};

const ScrollArea = props => (
    // eslint-disable-next-line tpe/no-props-spread -- TODO: legacy props spread (baseline)
    <Scrollbars renderThumbVertical={renderThumb} renderThumbHorizontal={renderThumb} {...props} />
);

export default ScrollArea;
